import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { useSubmotive3Detail } from './hook';
import { Submotive3Data } from './data';
import { Submotive3ParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    SUBMOTIVE3_NEW,
    SUBMOTIVE3,
    SUBMOTIVE3_EDIT,
    SUBMOTIVE3_DETAIL,
} from '../../../../../routes/paths';
import { Submotive3RegisterHistory } from './registerHistory';

export const Submotive3Detail = () => {
    const {
        submotive3,
        submotive3Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive3Detail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle submotivo 3"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive3?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE3_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE3,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE3_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE3_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive3?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <Submotive3ParamsHistorical
                            historical={submotive3Historical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <Submotive3Data data={submotive3} />
                </LayoutModule>
            </LayoutModule>
            <Submotive3RegisterHistory submotive3={submotive3} />
        </>
    );
};
